export class Node {
    constructor() {
        this.computes = [];
        this.conditions = [];
    }
    addCompute(compute) {
        this.computes.push(compute);
        return this;
    }
    addCondition(condition) {
        this.conditions.push(condition);
        return this;
    }
    canExecute(module) {
        for (const com of this.computes) {
            if (!com.process(module)) {
                return false;
            }
        }
        if (this.conditions.length === 0)
            return true;
        for (const con of this.conditions) {
            if (con.test(module)) {
                return true;
            }
        }
        return false;
    }
    execute(module) {
        for (const con of this.conditions) {
            con.execute(module);
        }
    }
    abort(module) {
        for (const con of this.conditions) {
            con.abort(module);
        }
    }
}
export class Selector extends Node {
    constructor() {
        super(...arguments);
        this.children = [];
    }
    add(node) {
        this.children.push(node);
        return this;
    }
    findGesture(module) {
        for (const child of this.children) {
            if (child.canExecute(module)) {
                child.execute(module);
                const result = child.findGesture(module);
                if (result) {
                    return result;
                }
                child.abort(module);
            }
        }
        return undefined;
    }
}
export class GestureNode extends Node {
    constructor(gesture) {
        super();
        this.gesture = gesture;
    }
    canExecute(module) {
        return super.canExecute(module) && this.gesture.enabled;
    }
    findGesture() {
        return this.gesture;
    }
}
